import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#111",
      d: "M11.767 4.233A5.305 5.305 0 0 0 8 2.667a5.333 5.333 0 1 0 0 10.666c2.487 0 4.56-1.7 5.154-4h-1.387a3.994 3.994 0 0 1-6.595 1.495A4 4 0 0 1 8 4c1.107 0 2.094.46 2.814 1.187L8.667 7.333h4.667V2.667l-1.567 1.566Z"
    }, null, -1)
  ])))
}
export default { render: render }